import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardToggleSwitch: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardToggleSwitch_dataBinding_panelTitle',
    helpId: '6a7fcd91-32ea-4805-84a2-9d4acb87afb0',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardToggleSwitchRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardToggleSwitch_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardToggleSwitch_dataBinding_checked_label',
          prop: 'checked',
          supportedFieldTypes: [FieldType.boolean],
          defaultFieldType: FieldType.boolean,
        },
        {
          title: 'dsgnsys_DashboardToggleSwitch_dataBinding_tooltip_label',
          prop: 'tooltip',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
